import { AnalyticsEvent } from './types';
import { datadogLogs } from '@datadog/browser-logs';

type FetchAnalyticsProps = {
  analyticsEvent: AnalyticsEvent;
  url: string;
};

export async function fetchAnalytics({
  analyticsEvent,
  url,
}: FetchAnalyticsProps) {
  //TODO: Don't test on Cypress
  if (window && (window as any).Cypress) {
    return;
  }

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(analyticsEvent),
  };

  try {
    await fetch(url, options);
  } catch (e) {
    datadogLogs.logger.error('Failed to send analytics event:', {
      error: e.message,
      url,
      trackEvent: analyticsEvent,
    });
  }
}

export default fetchAnalytics;
